import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, OccEndpointsService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { CustomAddToCartService } from "src/app/custom-add-to-cart/custom-add-to-cart.service";
import { CustomProdPgService } from "src/app/custom-prod-pg/custom-prod-pg.service";
import { DataLayerService } from "src/app/shared/services/data-layer.service";
import { ExcelDownloadService } from "src/app/shared/services/excel-download.service";
import { SharedService } from "src/app/shared/services/shared.service";
import * as _ from 'underscore';
import { AccountOverviewService } from "../../account-overview.service";

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'app-upload-details',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './upload-details.component.html',
  styleUrls: ['./upload-details.component.scss']
})
export class UploadDetailsComponent implements OnInit {
  @Input() public uploadDetails;
  uploadOrderRes: any;
  displayData: any;
  itemsArr: any = [];
  files: any;
  uploadJsonData: any;
  isLoadingDone: boolean;
  userId: any;
  cartId: any;
  private interval: any;
  mediaUrl: any;
  baseUrl: any;
  baseSiteId: any;
  blockOrder: boolean;
  allCartItemsSub: Subscription;
  //After upgrade ActiveCartService causing - NullInjectorError: R3InjectorError(AppModule)[ActiveCartService -> ActiveCartService -> ActiveCartService]
  //dont add back ActiveCartService
  constructor(private readonly modalService: NgbModal,
    public readonly accountService: AccountOverviewService,
    public readonly excelService: ExcelDownloadService,
    private readonly customProdPgService: CustomProdPgService,
    private readonly user: UserAccountFacade,
    private readonly cdr: ChangeDetectorRef,
    private readonly occEndPoint: OccEndpointsService,
    private readonly baseSite: BaseSiteService,
    private readonly sharedService?: SharedService,
    private readonly addToCartService?: CustomAddToCartService,
    private readonly _dataService?: DataLayerService
  ) { }

  ngOnInit(): void {
    this.baseSite.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.user.get().subscribe((resp) => {
      this.userId = resp;
    });
    this.allCartItemsSub = this.addToCartService.allCartItems$.subscribe((res) => {
      if (res) {
        let cartItems = res?.carts;
        cartItems = cartItems[cartItems?.length - 1];
        this.cartId = cartItems?.code;
        this.uploadExcelOrder();
        this.cdr.detectChanges();
        this.allCartItemsSub?.unsubscribe();
      }
    });
    this.baseUrl = this.occEndPoint.getBaseUrl({ baseUrl: true, prefix: false, baseSite: false, });
    this.blockOrder = this.sharedService.getLocalStorage('blockOrder');
  }

  close(): void {
    this.modalService.dismissAll();
  }

  uploadExcelOrder() {
    this.isLoadingDone = false;
    if (this.uploadDetails != null && this.uploadDetails != '' && this.uploadDetails != undefined) {
      let selectedFile: File = this.uploadDetails;
      let formData: FormData = new FormData();
      formData.append('selectedFile', selectedFile, selectedFile.name);
      this.accountService.uploadExcelOrder(this.userId?.uid, this.cartId, formData).subscribe((res) => {
        if (res.status === "SUCCESS") {
          this.interval = setInterval(() => {
            this.uploadExcelOrderStatus();
          }, 2000)
        } else {
          this.isLoadingDone = true;
          this.modalService.dismissAll();
        }
      }, (error) => {
        this.isLoadingDone = true;
        this.modalService.dismissAll();
      })
    }
  }

  uploadExcelOrderStatus() {
    this.accountService.uploadExcelOrderStatus(this.userId?.uid, this.cartId).subscribe((res) => {
      if (Object.keys(res).length !== 0) {
        this.isLoadingDone = true;
        this.uploadDetails = undefined;
        clearInterval(this.interval);
        this.uploadOrderRes = res;
        this.mediaUrl = `${this.baseUrl}${res?.errorFileDownloadUrl}`;
        this.displayData = this.uploadOrderRes?.fileUploadStatus;
        this.displayData?.locationsMap?.forEach(locData => {
          locData?.value?.mergedValidProducts?.forEach(element => {
            let array = element.key.split(":");
            element.name = array[0];
            element.quantity = array[1];
            const imagesFormat = _.clone(
              _.findWhere(element?.value?.images, { format: 'thumbnail' })
            );
            if (imagesFormat) {
              imagesFormat.url = `${this.baseUrl}${imagesFormat?.url}`;
              element.value.PRIMARY = imagesFormat;
            }
          });
        });
        this.cdr.detectChanges();
      }
    }, (error) => {
      this.isLoadingDone = true;
      clearInterval(this.interval);
    })
  }

  uploadOrder(data) {
    this.isLoadingDone = false;
    let details = {
      uploadOrders: []
    }
    let arrData
    arrData = Object.values(data)[0];
    arrData.forEach(element => {
      let obj = {
        customer: element.Customer,
        material: element.Material,
        quantity: element.Quantity,
        ponumber: element['PO#']
      }
      details.uploadOrders.push(obj)
    });
    this.accountService.uploadAccount(this.userId?.uid, this.cartId, details).subscribe((res) => {
      this.isLoadingDone = true;
      this.uploadOrderRes = res;
      this.displayData = this.uploadOrderRes;
      this.displayData?.locationsMap?.forEach(locData => {
        locData?.value?.mergedValidProducts?.forEach(element => {
          let array = element.key.split(":");
          element.name = array[0];
          element.quantity = array[1];
        });
      });
    }, (error) => {
      this.isLoadingDone = true;
    })
  }

  addToCart() {
    this.accountService.uploadAddToCart(this.userId?.uid, this.cartId, this.uploadOrderRes?.fileUploadStatus).subscribe((res) => {
      if (res.status == 'success') {
        const _win: any = window;
        let arrayForLocations = [];
        this.uploadOrderRes?.fileUploadStatus?.locationsMap?.forEach(el => {
          this._dataService.addtoDataLayer('upload_order', el.value.mergedValidProducts, this.uploadOrderRes?.fileUploadStatus?.locationsMap, el.key);
        })
        this.addToCartService.allCartItems$.pipe(take(1)).subscribe((res) => {
          if (res) {
            this.cartId = res?.carts[0]?.code;
            this.customProdPgService.minicartUpdate.next(this.cartId);
          }
        });
      }
      this.modalService.dismissAll();
    })
  }

  uploadFiles(event) {
    if (event.target.files[0].type === EXCEL_TYPE) {
      this.excelToJson(event.target.files[0]);
    }
  }

  onFileChanges(pFileList: File[]) {
    this.files = Object.keys(pFileList).map(key => pFileList[key]);
    if (this.files[0].type === EXCEL_TYPE) {
      this.excelToJson(this.files[0]);
    }
  }

  excelToJson(ev) {
    if (ev != null && ev != '' && ev != undefined) {
      this.uploadDetails = ev;
      this.uploadExcelOrder();
    }
  }

  public downloadXls() {
    let data: any;
    this.accountService.orderTemplateDownload(this.baseSiteId).subscribe((res) => {
      data = res;
      data.forEach((element, index) => {
        if (index == 0)
          element.Customer = JSON.parse(localStorage.getItem('accountId'));
      });
      let name = this.baseSiteId == "vax" ? 'VAXlistOrderTemplate' : 'VSHlistOrderTemplate';
      this.excelService.exportAsExcelFile(data, name, true);
    })
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
}